// Keep supplier bundle names here; calendar titles and artwork may differ.
export const GAME_FOLDERS = Object.freeze({
    santaHeist: 'digitas-santa-climb',
    prawnBbq: 'digitas-flappy-chicken',
    matchWin: 'digitas-memory-match-and-win',
    christmasConnections: 'digitas-christmas-connections',
    santaStack: 'digitas-trixology-classic-responsive-hd',
    snackSprint: 'digitas-chomp-chase',
    merryMindMaster: 'digitas-trivia-quiz-hd',
    hamHurl: 'digitas-cornhole-toss',
    festiveFetch: 'digitas-catch-the-snacks',
    pythonPursuit: 'digitas-snake-king',
    whackAPana: 'digitas-whack-a-mole-cartooney-fixed-resolution-hd',
});

// Game assignment is shared so desktop and mobile cannot point the same day at
// different bundles. cellType remains layout-specific below.
export const GAME_SCHEDULE = Object.freeze([
    { day: 1, game: GAME_FOLDERS.santaHeist, activeDayBg: 'before:bg-santa-heist' },
    { day: 2, game: GAME_FOLDERS.prawnBbq, activeDayBg: 'before:bg-prawn-bbq' },
    { day: 3, game: GAME_FOLDERS.matchWin, gameType: 'quiz', quizQuestion: 1, activeDayBg: 'before:bg-merry-match-win' },
    { day: 4, game: GAME_FOLDERS.christmasConnections, gameType: 'quiz', quizQuestion: 1, activeDayBg: 'before:bg-christmas-connections' },
    { day: 5, game: GAME_FOLDERS.santaStack, activeDayBg: 'before:bg-santa-stack' },
    { day: 6, game: GAME_FOLDERS.snackSprint, activeDayBg: 'before:bg-santa-snack-sprint' },
    { day: 7, game: GAME_FOLDERS.santaHeist, activeDayBg: 'before:bg-santa-heist' },
    { day: 8, game: GAME_FOLDERS.prawnBbq, activeDayBg: 'before:bg-prawn-bbq' },
    { day: 9, game: GAME_FOLDERS.merryMindMaster, gameType: 'quiz', quizQuestion: 1, activeDayBg: 'before:bg-merry-mind-master' },
    { day: 10, game: GAME_FOLDERS.hamHurl, activeDayBg: 'before:bg-ham-hurl' },
    { day: 11, game: GAME_FOLDERS.festiveFetch, activeDayBg: 'before:bg-festive-fetch' },
    { day: 12, game: GAME_FOLDERS.pythonPursuit, activeDayBg: 'before:bg-python-pursuit' },
    { day: 13, game: GAME_FOLDERS.matchWin, gameType: 'quiz', quizQuestion: 2, activeDayBg: 'before:bg-merry-match-win' },
    { day: 14, game: GAME_FOLDERS.prawnBbq, activeDayBg: 'before:bg-prawn-bbq' },
    { day: 15, game: GAME_FOLDERS.santaStack, activeDayBg: 'before:bg-santa-stack' },
    { day: 16, game: GAME_FOLDERS.whackAPana, activeDayBg: 'before:bg-whack-pana' },
    { day: 17, game: GAME_FOLDERS.santaHeist, activeDayBg: 'before:bg-santa-heist' },
    { day: 18, game: GAME_FOLDERS.christmasConnections, gameType: 'quiz', quizQuestion: 2, activeDayBg: 'before:bg-christmas-connections' },
    { day: 19, game: GAME_FOLDERS.snackSprint, activeDayBg: 'before:bg-santa-snack-sprint' },
    { day: 20, game: GAME_FOLDERS.merryMindMaster, gameType: 'quiz', quizQuestion: 2, activeDayBg: 'before:bg-merry-mind-master' },
    { day: 21, game: GAME_FOLDERS.hamHurl, activeDayBg: 'before:bg-ham-hurl' },
    { day: 22, game: GAME_FOLDERS.prawnBbq, activeDayBg: 'before:bg-prawn-bbq' },
    { day: 23, game: GAME_FOLDERS.santaHeist, activeDayBg: 'before:bg-santa-heist' },
    { day: 24, game: GAME_FOLDERS.matchWin, gameType: 'quiz', quizQuestion: 3, activeDayBg: 'before:bg-merry-match-win' },
]);

const DESKTOP_CELL_TYPES = Object.freeze({
    1: 'big', 2: 'big', 3: 'big', 4: 'big', 5: 'tall', 6: 'big',
    7: 'small', 8: 'wide', 9: 'wide', 10: 'wide', 11: 'tall', 12: 'wide',
    13: 'big', 14: 'wide', 15: 'small', 16: 'wide', 17: 'tall', 18: 'small',
    19: 'small', 20: 'wide', 21: 'big', 22: 'wide', 23: 'tall', 24: 'big',
});

const MOBILE_CELL_TYPES = Object.freeze({
    1: 'big', 2: 'wide', 3: 'small', 4: 'wide', 5: 'small', 6: 'tall',
    7: 'wide', 8: 'tall', 9: 'wide', 10: 'small', 11: 'wide', 12: 'wide',
    13: 'big', 14: 'wide', 15: 'small', 16: 'tall', 17: 'big', 18: 'tall',
    19: 'small', 20: 'small', 21: 'big', 22: 'small', 23: 'small', 24: 'wide',
});

const getActiveDayStyle = (day) => ({
    size: day === 1
        ? 'before:w-[143px] before:h-[80px]'
        : 'before:w-[143px] before:h-[79px]',
    position: 'before:bg-center',
    extra: 'mt-[10px]',
});

const buildCalendarData = (cellTypes) => ({
    data: GAME_SCHEDULE.map((item) => ({
        ...item,
        status: '',
        cellType: cellTypes[item.day],
        activeDayStyle: getActiveDayStyle(item.day),
    })),
});

export const calendarData = buildCalendarData(DESKTOP_CELL_TYPES);
export const calendarDataMobile = buildCalendarData(MOBILE_CELL_TYPES);
